export default __webpack_public_path__ + "static/media/empresa-de-mulheres.cd728e30.png";